storefrontApp.service('downloadService', ['$http', '$q', '$timeout', '$rootScope', 'notificationModalService', 
    function ($http, $q, $timeout, $rootScope, notificationModalService) {
    return {
        downloadFileByChuncks: function(downloadRequest,
            hideCompletedNotification,
            hideStartedNotification,
            completedCallbackEmitName,
            isZipAndEmail){
                var chunkSize = 1024 * 1024; // 1MB per chunk
                var totalFileSize = 0; // To be fetched once the first chunk is downloaded
                var chunkIndex = 0;
                var fileChunks = [];
                var fileName = "";


                // Function to download all chunks sequentially
                function downloadAllChunks(obj) {
                    var deferred = $q.defer();

                    // Reset variables
                    chunkSize = 1024 * 1024; 
                    totalFileSize = 0; 
                    chunkIndex = 0;
                    fileChunks = [];
                    fileName = "";
                
                    var downloadedBytes = 0;
                    var progressPercentage = 0;
                
                    //loaderService.showProgress();


                        //modalService.open("showdownloadProgressModal");
                        $rootScope["showdownloadProgressModal"] = true;
                        $rootScope.progress = 0;
                
                    var readableStream = new ReadableStream({
                        start: function(controller) {
                            function downloadNextChunk() {
                                obj.chunkIndex = chunkIndex;
                                obj.chunkSize = chunkSize;

                                // Add explicit promise handling

                                $q.when(downloadChunk(obj))
                                    .then(function(response) {
                                        if (!response || !response.data) {
                                            throw new Error('No data received in chunk response');
                                        }
                                    
                                        downloadedBytes += response.data.byteLength;
                                        if (totalFileSize > 0) {
                                            progressPercentage = Math.round((downloadedBytes / totalFileSize) * 100);
                                            //loaderService.updateProgress(progressPercentage);

                                            $timeout(function() {$rootScope.progress = progressPercentage;})
                                        }
                                    
                                        controller.enqueue(new Uint8Array(response.data));
                                        chunkIndex++;
                                        if (!totalFileSize) {
                                            console.error('Total file size not set - cannot continue');
                                            controller.close();
                                            return;
                                        }
                                    
                                        if (chunkIndex * chunkSize < totalFileSize) {
                                            downloadNextChunk();
                                        } else {
                                            controller.close();
                                        }
                                    })
                                    .catch(function(error) {
                                        console.error('Error in chunk download chain:', error);
                                        controller.error(error);
                                        deferred.reject(error);
                                    });
                            }
                        
                            // Start the first chunk download
                            downloadNextChunk();
                        }
                    });
                
                    // Create a response from the stream and trigger download
                    new Response(readableStream)
                        .blob()
                        .then(function(blob) {
                        try{
                            if (downloadRequest.zipOptions.toLowerCase() == "email"){
                                $rootScope.notificationModal = notificationModalService.getNotificationModal(
                                    "DOWNLOAD"
                                );
                            } else if (totalFileSize > 0){
                            var url = URL.createObjectURL(blob);
                            var link = document.createElement('a');
                            link.href = url;
                            link.download = fileName || obj.productid + ".zip";

                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);
                            $rootScope.notificationModal = notificationModalService.getNotificationModal(
                                "DOWNLOAD"
                            );
                            } else {                                
                            $rootScope.notificationModal = notificationModalService.getNotificationModal(
                                "ERROR"
                            );
                            }
                        }
                        finally{
                            //loaderService.hide();
                            //modalService.close("showdownloadProgressModal");
                            $rootScope["showdownloadProgressModal"] = false;
                            //$rootScope.$emit("ShowNotificationModal", {
                            //    modalKey: "downloadCompleted",
                            //});
                            $rootScope.progress = 0;
                            $rootScope.$apply();
                        }
                            //$scope.progress = 0;
                            deferred.resolve();
                        })
                        .catch(function(error) {
                            console.error('Error in blob creation/download:', error);
                            //modalService.close("showdownloadProgressModal");
                            $rootScope["showdownloadProgressModal"] = false;
                            $rootScope.progress = 0;
                            deferred.reject(error);
                        });
                    
                    return deferred.promise;
                }
            
                // Modify downloadChunk to return a proper promise
                function downloadChunk(obj) {
                    return $http.post('/storefrontapi/downloadorder', obj, {
                        responseType: 'arraybuffer',
                        headers: {
                            'Accept': 'application/octet-stream'
                        }
                    }).then(
                        function successCallback(response) {
                            // Set total file size from first chunk
                            if (!totalFileSize) {
                                totalFileSize = parseInt(response.headers('X-File-Size'), 10);
                            }
                        
                            // Get filename from Content-Disposition
                            var contentDisposition = response.headers('Content-Disposition');
                            if (contentDisposition) {
                                var matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                                if (matches && matches[1]) {
                                    fileName = matches[1].replace(/['"]/g, '');
                                }
                            }
                        
                            return response;
                        },
                        function errorCallback(error) {
                            console.error('HTTP request failed:', error);
                            throw error;
                        }
                    );
                }

                // Zip & Email: backend queues email and does not stream file or return X-File-Size
                var zipOpt = (downloadRequest.zipOptions && downloadRequest.zipOptions.toLowerCase()) || '';
                if (zipOpt === 'email') {
                    $rootScope["showdownloadProgressModal"] = true;
                    $rootScope.progress = 0;
                    var emailRequest = {};
                    for (var k in downloadRequest) {
                        if (downloadRequest.hasOwnProperty(k)) { emailRequest[k] = downloadRequest[k]; }
                    }
                    emailRequest.chunkIndex = 0;
                    emailRequest.chunkSize = 0;
                    $http.post('/storefrontapi/downloadorder', emailRequest, {
                        headers: { 'Accept': 'application/json' }
                    }).then(
                        function() {
                            $rootScope["showdownloadProgressModal"] = false;
                            $rootScope.progress = 0;
                            $rootScope.notificationModal = notificationModalService.getNotificationModal("DOWNLOADEMAIL");
                        },
                        function(error) {
                            console.error('Email download request failed:', error);
                            $rootScope["showdownloadProgressModal"] = false;
                            $rootScope.progress = 0;
                            $rootScope.notificationModal = notificationModalService.getNotificationModal("ERROR");
                        }
                    );
                    return;
                }

                downloadAllChunks(downloadRequest);
            },
        getProductRelatedProjects: function (productId) {
            return $http.get(
                "storefrontapi/learningcenter/getproductprojects?itemId=" +
                    productId
            );
        },
        getProjectPDFUrl: function (projectId) {
            return $http.get(
                "storefrontapi/learningcenter/projectpdfurlbyid?projId=" +
                    projectId
            );
        },
        downloadFileFromUrl: function (url, fileName) {
            return fetch(url)
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error("Project PDF download failed");
                    }
                    return response.blob();
                })
                .then(function (blob) {
                    var objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
                    var link = document.createElement("a");
                    link.href = objectUrl;
                    link.download = (fileName || "Project") + ".pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    (window.URL || window.webkitURL).revokeObjectURL(objectUrl);
                });
        }
    }
}])